import { Flex, Text, TextContainer, TextHeading, UnstyledButton } from "@wayflyer/flyui";
import { useState } from "react";
import { useIntl } from "react-intl";
import { styled } from "styled-components";

import { PlatformDetailsContainer } from "./platform-connection-list.styles";

export const PlatformDetails = ({
  name,
  domain,
  additionalDetails,
}: {
  name: string;
  domain?: string;
  additionalDetails?: Array<string>;
}) => (
  <PlatformDetailsContainer>
    <Flex direction="column" gap="2">
      <TextContainer spacing="0">
        <TextHeading>{name}</TextHeading>
        {domain && <Text>{domain}</Text>}
      </TextContainer>
      {additionalDetails && <DetailList details={additionalDetails} />}
    </Flex>
  </PlatformDetailsContainer>
);

const InlineButton = styled(UnstyledButton)`
  &:hover,
  &:focus,
  &:active {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

const DetailList = ({ details }: { details: Array<string> }) => {
  const defaultShown = 4;
  const shouldCollapse = details.length > defaultShown;
  const [collapsed, setCollapsed] = useState(shouldCollapse);
  const intl = useIntl();

  const usedDetails = shouldCollapse && collapsed ? details.slice(0, defaultShown) : details;

  const expandText = intl.formatMessage(
    {
      id: "platform-details: expand additional details",
      defaultMessage: "{count} more...",
    },
    { count: details.length - defaultShown }
  );

  const collapseText = intl.formatMessage({
    id: "platform-detials: collapse additional details",
    defaultMessage: "Show less...",
  });

  return (
    <TextContainer spacing="0">
      {usedDetails.map((property) => (
        <Text key={property}>{property}</Text>
      ))}
      {shouldCollapse && (
        <InlineButton onClick={() => setCollapsed(!collapsed)}>
          <Text color="positive">{collapsed ? expandText : collapseText}</Text>
        </InlineButton>
      )}
    </TextContainer>
  );
};
